import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import ApiService from '../../services/apiService';
import Authorization from './authorization';
import MessageGrid from '../purchaseRequisition/messageGrid';
import "../../Assets/styles/addmenu.css"
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import { BarLoader, ClipLoader } from 'react-spinners';
import moment from 'moment';
import UpdateItemGrid from './updateItemList';
import { getCompany, getUserName } from '../../../Redux/selecters';
import { useSelector } from 'react-redux';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import UpdateAttachment from '../Attachment/UpdateAttachment';

const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
})
const UpdatePurchaseOrder = () => {
    const apiService = new ApiService();
    const [activeTab, setActiveTab] = useState(0);
    const [SupplierTab, setSupplierTab] = useState(false);
    const { currencyPrecision } = useCurrency();
    const [POTab, setPOTab] = useState(true);
    const [CostTab, setCostTab] = useState(false);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [messageData, setMessageData] = useState([]);
    const [authorizationData, setAuthorizationData] = useState([]);
    const [ItemsData, setRequisitionData] = useState([]);
    const [suppliers, setSupplier] = useState([]);
    const [payments, setPayments] = useState([]);
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const [isVatExcluded, setIsVatExcluded] = useState(false);
    const [isDiscountPercentage, setIsDiscountPercentage] = useState(true);
    const [usersDetails, setUser] = useState([]);
    const [Supplier, setSupplierData] = useState([]);
    const [poNumber, setPONumber] = useState([]);
    const [SupplierID, setSupplierID] = useState([]);
    const [SupplierContact, setSupplierContact] = useState();
    const [Payment, setPayment] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const [cost1, setCost1] = useState([]);
    const [cost2, setCost2] = useState([]);
    const [cost3, setCost3] = useState([]);
    const [loader, setLoader] = useState(false);
    const [cost4, setCost4] = useState([]);
    const itemData = location.state;
    const [LazyLoading, setLazyLoading] = useState(true);
    const userName = useSelector(getUserName);
    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const Company = useSelector(getCompany);

    const [preview, setPreview] = useState();
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const closeModal = () => setAttachmentModal(false);
    const handleOpen = () => setAttachmentModal(true);
    const [isXtreamCompany, setXtreamCompany] = useState(false);

    const formatDateToDatetimeLocal = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };
    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    };


    useEffect(() => {
        checkCompanyName();
    }, [Company]);

    useEffect(() => {
        const item = location.state;
        const getApprovalUser = async () => {
            try {
                const params = new URLSearchParams();
                params.append('DocNo', itemData?.pOrderNo);
                params.append('DocumentType', "Purchase Order");
                const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
                setUser(response.data.result);
                const PaymentResponse = await apiService.get('GET_EPAYMENT');
                setPayments([{ value: null, description: 'None' }, ...PaymentResponse?.data?.result]);
                if (currencyPrecision) {
                    setSelectedCurency({ label: currencyPrecision.code, value: currencyPrecision });
                    setFormData({ exchangeRate: currencyPrecision?.conversionRate })
                }
                const SupplierResponse = await apiService.get('GET_SUPPLIER_KANOO');
                setSupplier([
                    { value: null, supplierName: 'None' },
                    { value: null, record_Id: 'None' },
                    ...SupplierResponse?.data?.result]);

                let cost1 = await apiService.get('GET_COST_ONE')
                setCost1(cost1?.data?.result)
                let cost2 = await apiService.get('GET_COST_TWO')
                setCost2(cost2?.data?.result)
                let cost3 = await apiService.get('GET_COST_THREE')
                setCost3(cost3?.data?.result)
                let cost4 = await apiService.get('GET_COST_FOUR')
                setCost4(cost4?.data?.result)
                setIsVatExcluded(item.costCenter5 === "excluded" ? true : false)
                const selectedpaymentTerm = PaymentResponse?.data?.result?.find(payment => payment?.description === item?.terms);
                if (selectedpaymentTerm) {
                    setPayment({ label: selectedpaymentTerm?.description, value: selectedpaymentTerm })
                }
                const selectedSuplier = SupplierResponse?.data?.result?.find(sup => sup?.supplierName === item?.vendorName);
                if (selectedSuplier) {
                    setSupplierData({ label: selectedSuplier?.supplierName, value: selectedSuplier })
                    setSupplierID({ label: selectedSuplier?.record_Id, value: selectedSuplier })
                    setSupplierContact(selectedSuplier?.phoneNo1)
                }
                const formattedPODate = item?.docDate ? formatDateToDatetimeLocal(item?.docDate) : getCurrentLocalDatetime();
                const formattedDelivDate = item.deliveryDate ? formatDateToDatetimeLocal(item.deliveryDate) : getCurrentLocalDatetime();
                setFormData({
                    PayOrderNo: item?.pOrderNo,
                    Remarks: item.remarks,
                    DocumentDate: formattedPODate,
                    deliveryDate: formattedDelivDate,
                    deliveryPoint: item.deliveryPoint,
                    location: item.location,
                    contactPerson: item.contactPerson,
                    requisitionNo: item.requisitionNo,
                    Department: item.department,
                    Description: item.description,
                    QuotationReq: item.quotationRef,
                    BuyerName: item?.modifiedBy,
                    lPOType: { label: item?.fax, value: item?.fax },
                    ContactNo: item?.contractNo,
                    RequisitionType: { label: item?.docId, value: item?.docId },
                    costCenter1: { label: item?.costCenter1, value: item?.costCenter1 },
                    costCenter2: { label: item?.costCenter2, value: item?.costCenter2 },
                    costCenter3: { label: item?.costCenter3, value: item?.costCenter3 },
                    costCenter4: { label: item?.costCenter4, value: item?.costCenter4 },
                });
                setLazyLoading(false)
                let attachparam = `?DocNo=${itemData.pOrderNo}&DocType=${"PurchaseOrder"}`;
                const AttachmentResponse = await apiService.getApiParamater("GET_ATTACHMENT", attachparam);
                const existingAttachments = AttachmentResponse?.data?.result || [];
                if (existingAttachments) {
                    setAttachments(mapAttachmentsFromApi(existingAttachments));
                }

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        setPONumber(item?.pOrderNo)
        if (location.state) {
            getApprovalUser()
        }

    }, [location.state]);
    const [formData, setFormData] = useState({
        PayOrderNo: "",
        Remarks: "",
        DocumentDate: "",
        SupplierContact: "",
        deliveryDate: "",
        deliveryPoint: "",
        location: "",
        contactPerson: "",
        requisitionNo: "",
        RequisitionType: "",
        ContactNo: "",
        lPOType: { label: "Commercial", value: "Commercial" },
        currencyCode: "",
        QuotationReq: "",
        costCenter1: "",
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
        CostCentre5: "",
        exchangeRate: "",
        Description: "",
        BuyerName: "",
        vendorId: "",
        vendorName: "",
        OrderType: "",
        paymentTerm: [],
        SupplierDep: [],
    });

    const checkCompanyName = () => {
        const DB = localStorage.getItem('DataBase');
        const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
        const defaultCompany = companies.find(comp => comp.dataDB === DB);
        const companyName = defaultCompany?.companyName?.toLowerCase() || '';
        const isXtreamCashier = companyName.includes('accountcode') || companyName.includes('kanoo');
        setXtreamCompany(isXtreamCashier);
    };

    const mapAttachmentsFromApi = (apiData) => {
        const validFiles = apiData.filter(
            a => a.fileName && a.fileName.trim() !== ""
        );

        return [
            ...validFiles.map(item => ({
                id: Date.now() + Math.random(), // UI id
                dbId: item.rcno,                // backend id
                file: null,                     // existing file (no File object)
                fileName: item.fileName,
                remarks: item.remarks || "",
                isNew: false,
                isDeleted: false,
            })),
            createEmptyRow()
        ];
    };
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleMessage = (data) => {
        setMessageData(data);
        console.log(data, 'reqData')
    };
    const handleRequisitionData = (data) => {
        setRequisitionData(data);
        console.log(data, 'reqData')
    };
    const handleAuthorization = (data) => {
        setAuthorizationData(data);
        console.log(data, 'reqData')
    };
    const handlecurChange = (selectedOption) => {
        setFormData({ ...formData, currencyCode: selectedOption?.value?.code });
    };
    const orderType = [
        { value: 'Local Purchase', label: 'Local Purchase' },
        { value: 'Import Purchase', label: 'Import Purchase' },
        { value: 'Fixed Assist Purchase', label: 'Fixed Assist Purchase' },
        { value: 'Non Inventory Purchase', label: 'Non Inventory Purchase' },
        { value: 'Hire Purchase', label: 'Hire Purchase' },
        { value: 'Internal Pay Order', label: 'Internal Pay Order' },
        { value: 'Open Pay Order', label: 'Open Pay Order' },
    ];
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handlePayChange = (selectedOption) => {
        setPayment(selectedOption)
    };
    const handleSupplierChange = (selectedOption) => {
        setSupplierData({ label: selectedOption?.label, value: selectedOption })
        setSupplierID({ label: selectedOption?.value?.record_Id, value: selectedOption })
        setSupplierContact(selectedOption?.value?.phoneNo1)
        setPayment({ label: selectedOption?.value?.paymentTerm, value: selectedOption })
    }
    const handleDepChange = (selectedOption) => {
        setFormData({ ...formData, SupplierDep: selectedOption });
    };
    const itemType = [
        { value: 'None', label: 'None' },
        { value: 'Inventory', label: 'Inventory' },
        { value: 'Fixed Asset', label: 'Fixed Asset' },
        { value: 'Services', label: 'Services' },
    ];

    const LPOType = [
        { value: 'Commercial', label: 'Commercial' },
        { value: 'Family', label: 'Family' },
    ];
    const UpdatePO = async () => {
        setLoader(true)
        if (ItemsData.length === 0) {
            toast.warning("Please add items");
            setLoader(false)
            return;
        } else if (!Supplier.label) {
            toast.warning("Please Select Supplier");
            setLoader(false)
            return;
        }
        for (const item of ItemsData) {
            if (!item.itemDescription) {
                toast.warning(`Please Select Item`);
                setLoader(false);
                return;
            } else if (!item.qty) {
                toast.warning(`Please enter ${item.itemDescription} quantity`);
                setLoader(false);
                return;
            } else if (!item.qty || parseFloat(item.qty) <= 0) {
                toast.warning(`${item.itemDescription} quantity must be greater than 0`);
                setLoader(false);
                return;
            } else if (!item.baseAmount || parseFloat(item.baseAmount) <= 0) {
                toast.warning(`${item.itemDescription} unit price must be greater than 0`);
                setLoader(false);
                return;
            }
        }
        const totalAmount = ItemsData.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0)
        try {
            const apiService = new ApiService()
            const prDetailsData = ItemsData.map((item, index) => ({
                pOrderNo: poNumber,
                deliveryDate: formData.deliveryDate,
                status: 0,
                isActive: true,
                vatPerc: item?.vat,
                vatDesc: item?.vatDec,
                vatAmount: Number(item.vatAmount).toFixed(SelectedCurrency?.value?.precision || 2),
                vatUnitPrice: Number(item.vatAmount / item.qty).toFixed(SelectedCurrency?.value?.precision || 2),
                vatBaseAmount: Number(item.vatAmount).toFixed(SelectedCurrency?.value?.precision || 2),
                requisitionNo: formData?.requisitionNo || '',
                srno: item?.srno,
                rsrno: index + 1,
                itemCode: item.ItemNo || item.recordId,
                itemDescription: item.itemDescription,
                uom: item.uom,
                qty: parseFloat(item.qty),
                baseUOM: item?.uom,
                baseQty: parseFloat(item.baseQty),
                specification: item.specification,
                convValue: parseFloat(item?.baseQty),
                unitPrice: Number(item.baseAmount).toFixed(SelectedCurrency?.value?.precision || 2),
                amount: Number(item.amount).toFixed(SelectedCurrency?.value?.precision || 2),
                baseAmount: Number(item.amount).toFixed(SelectedCurrency?.value?.precision || 2),
                discount: parseFloat(item.discount),
                discountPerc: isDiscountPercentage === true ? 1 : 0,
                cancelledQty: 0,
                returnQty: 0,
            }));
            const currentDatetimeUTC = new Date().toISOString();
            const userData = {
                docId: itemData.requisitionNo === formData?.requisitionNo ? formData.RequisitionType?.label : formData.RequisitionType,
                currencyCode: SelectedCurrency?.label,
                exchangeRate: SelectedCurrency?.value.conversionRate,
                modifiedOn: currentDatetimeUTC,
                modifiedBy: userName,
                // modifiedBy: formData.BuyerName,
                contractNo: formData?.ContactNo,
                poType: "POrder",
                fax: formData?.lPOType?.label || "0",
                costCenter5: isVatExcluded === true ? "excluded" : "Included",
                baseAmount: Number(totalAmount).toFixed(SelectedCurrency?.value?.precision || 2),
                amount: Number(totalAmount).toFixed(SelectedCurrency?.value?.precision || 2),
                quotationRef: formData?.QuotationReq,
                pOrderNo: itemData.pOrderNo,
                terms: Payment.label,
                vendorId: SupplierID?.label.toString(),
                vendorName: Supplier?.label,
                docDate: currentDatetimeUTC,
                attention: SupplierContact,
                location: formData?.location,
                department: formData?.Department,
                deliveryPoint: formData?.deliveryPoint,
                contactPerson: formData?.contactPerson,
                status: ItemsData?.status,
                description: formData?.Description,
                remarks: formData?.Remarks,
                costCenter1: formData?.costCenter1?.label,
                costCenter2: formData?.costCenter2?.label,
                costCenter3: formData?.costCenter3?.label,
                costCenter4: formData?.costCenter4?.label,
                costCenter5: isVatExcluded === true ? "excluded" : "Included",
                poDetails: prDetailsData,
                requisitionNo: formData?.requisitionNo || '',
                deliveryDate: formData.deliveryDate || currentDatetimeUTC,
                status: 0,
            };
            const response = await apiService.put("UPDATE_PO", userData);
            if (response?.data?.statusCode === 201 || 200) {
                const userData2 = {
                    docType: "POrder",
                    docId: poNumber,
                    status: 0,
                    remarks: formData?.Remarks,
                };
                if (attachments) {
                    let name = "PurchaseOrder"
                    let docNo = poNumber
                    handleUpload(name, docNo)
                }
                const response2 = await apiService.put("UPDATE_DOC_AUTHORIZATION_STATUS", userData2);
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', "POrder");
                paramsGet.append('docId', poNumber);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                if (response3?.data?.result.length > 0) {
                    const toEmails = response3?.data?.result?.map(user => user.userEmail);
                    const emailbody = {
                        toEmails: toEmails,
                        subject: "Purchase Order",
                        body: "",
                        docNo: poNumber,
                        srNo: 1,
                        docType: "POrder"
                    };
                    const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                }
                toast.success(`${poNumber} Updated successfully`);
                setLoader(false)
                navigate("/inventory/Purchase/Order")
            }
        } catch (error) {
            setLoader(false)
            console.error("Error Creating PR:", error);
        }
    };
    const handleVatChange = () => {
        setIsVatExcluded(!isVatExcluded);
    };
    const handlePyorderChange = (selectedOption) => {
        setFormData({ ...formData, OrderType: selectedOption });
    };
    const handleDiscountChange = () => {
        setIsDiscountPercentage(!isDiscountPercentage);
    };
    const handleCost1 = async (selectedOption) => {
        let param = `?CostCenter1=${selectedOption?.label}`
        let cost2 = await apiService.getApiParamater('GET_COST_TWO', param)
        if (cost2?.data?.result) {
            setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);
        } else {
            setCost2([])
        }
        setFormData({ ...formData, costCenter1: selectedOption });
    }
    const handleCost2 = (selectedOption) => {
        setFormData({ ...formData, costCenter2: selectedOption });
    }
    const handleCost3 = (selectedOption) => {
        setFormData({ ...formData, costCenter3: selectedOption });
    }
    const handleCost4 = (selectedOption) => {
        setFormData({ ...formData, costCenter4: selectedOption });
    }
    const handleBackClick = () => {
        window.history.back();
    };
    const handleItemTypeChange = (selectedOption) => {
        setFormData({ ...formData, RequisitionType: selectedOption });
    };
    // Attachment Functions
    const handleFileSelect = (file, id) => {
        setAttachments(prev => {
            const updated = prev.map(row =>
                row.id === id
                    ? {
                        ...row,
                        file,
                        fileName: file.name,
                        isNew: true
                    }
                    : row
            );

            return [...updated, createEmptyRow()];
        });
    };
    const handleRemarkChange = (id, value) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = (id) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id
                    ? { ...row, isDeleted: true }
                    : row
            )
        );
    }
    const handleView = (file) => {

        if (!file) return;
        if (file?.isNew === false) {
            setPreviewImage(file?.fileName);
        } else {
            setPreviewImage(URL.createObjectURL(file?.file));
        }
        setPreview(file)
        setPreviewModal(true);
    };
    const handleUpload = async (name, docNo) => {
        const formData = new FormData();
        attachments.forEach(({ file }) => {
            if (file instanceof File) {
                formData.append("Images", file, file.name);
            }
        });

        const response = await apiService.postMultiPart(
            "UPLOAD_FILE",
            formData
        );

        if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {

            const uploadedFileNames = response.data.result.split(",");
            let uploadedIndex = 0;

            const payload = {
                docFilesDtos: attachments
                    .filter(a => {
                        //  skip deleted
                        if (a.isDeleted === true) return false;

                        //  keep old files
                        if (a.fileName && a.fileName.trim()) return true;

                        //  keep new uploads only if file exists
                        if (a.isNew && a.file) return true;

                        //  skip empty rows
                        return false;
                    })
                    .map((a, index) => {

                        let fileName = a.fileName?.trim();
                        // 🔁 Assign uploaded filename ONLY to new attachments
                        if (!fileName && a.isNew) {
                            fileName = uploadedFileNames[uploadedIndex]?.trim();
                            uploadedIndex++;
                        }
                        return {
                            rcno: a?.dbId,
                            srno: index + 1,
                            docNo: docNo,
                            docType: name,
                            fileName,
                            remarks: a.remarks || "",
                        };
                    }),
                docNo: docNo,
            };

            await apiService.put("UPDATE_ATTACHMENT", payload);
        }

    };

    const handleTypeChange = (selectedOption) => {
        setFormData({ ...formData, lPOType: selectedOption });
    };
    return (
        <div className='px-4'>
            <div className='d-flex justify-content-between pt-3'>
                <h5 className='col mainInvHead'>Purchase Order</h5>
                <div className='d-flex gap-3'>
                    {itemData?.eye === false ?
                        <>
                            {loader === true ?
                                <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                                <button className='mainbtn ' type="submit" onClick={UpdatePO}><FaSave className='center mt-1 mx-2' /><div>Update</div></button>
                            }
                        </> : ""
                    }
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Purchase Order Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <>
                            <div className="form-group justify-content-between row pb-3">
                                <div className="col d-flex justify-content-between">
                                    <label htmlFor="RequisitionType" className="form-label center">LPO Type</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        value={formData.lPOType}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-70 p-0"
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        options={LPOType}
                                        onChange={(selectedOption) => handleTypeChange(selectedOption)}
                                    />
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="InvoiceNO" className="form-label">Purchase Order No</label>
                                    <input
                                        className="form-Input w-70"
                                        value={poNumber}
                                        name="poNumber"
                                        disabled
                                    />
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="DeliveryDate" className="form-label">Delivery Date</label>
                                    {itemData?.eye === true ?
                                        <input
                                            type="datetime" disabled
                                            className="form-Input w-70"
                                            id="DeliveryDate"
                                            value={moment(formData.deliveryDate).format('DD-MMM-YYYY')}
                                            name="deliveryDate"
                                        /> :
                                        <input
                                            type="datetime-local"
                                            className="form-Input w-70"
                                            id="DeliveryDate"
                                            value={formData.deliveryDate}
                                            onChange={handleInputChange}
                                            name="deliveryDate"
                                        />
                                    }
                                </div>
                            </div>
                            <div className="form-group row justify-content-between pb-3">
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="Currency" className="form-label">Currency </label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-70 p-0"
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        value={SelectedCurrency} isDisabled={itemData?.eye === true ? true : false}
                                        onChange={(e) => handlecurChange(e)}
                                    />
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="DocumentDate" className="form-label">Document Date</label>
                                    {itemData?.eye === true ?
                                        <input
                                            type="datetime" disabled
                                            className="form-Input w-70"
                                            id="DocumentDate"
                                            value={moment(formData.DocumentDate).format('DD-MMM-YYYY')}
                                            name="DocumentDate"
                                        /> :
                                        <input
                                            className='form-Input w-70'
                                            id="DocumentDate"
                                            value={formData.DocumentDate}
                                            type='datetime-local' disabled={itemData?.eye === true ? true : false}
                                            name="DocumentDate"
                                            onChange={handleInputChange}
                                        />}
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="deliveryPoint" className="form-label">Delivery Point</label>
                                    <input
                                        type="text"
                                        className="form-Input w-70"
                                        id="deliveryPoint" disabled={itemData.eye === true ? true : false}
                                        value={formData?.deliveryPoint}
                                        onChange={handleInputChange}
                                        name="deliveryPoint"
                                    />
                                </div>
                            </div>
                            <div className="form-group row justify-content-between pb-3">
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="ExchangeRate" className="form-label">Exchange Rate </label>
                                    <input
                                        type="number"
                                        className="form-Input w-70"
                                        disabled
                                        onWheel={(e) => e.target.blur()}
                                        id="exchangeRate"
                                        value={formData.exchangeRate}
                                        onChange={handleInputChange}
                                        name="exchangeRate"
                                    />
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="requisitionNo" className="form-label">Requisition No</label>
                                    <input
                                        className="form-Input w-70" name='requisitionNo'
                                        id="requisitionNo" disabled={itemData.eye === true ? true : false}
                                        value={formData.requisitionNo}
                                    />
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="location" className="form-label">Location</label>
                                    <input
                                        type="text"
                                        className="form-Input w-70"
                                        id="location" disabled={itemData.eye === true ? true : false}
                                        value={formData.location}
                                        onChange={handleInputChange}
                                        name="location"
                                    />
                                </div>
                            </div>
                            <div className="form-group row pb-3">
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="Description" className="form-label">Description</label>
                                    <input
                                        type="text"
                                        className="form-Input w-70"
                                        id="Description" disabled={itemData.eye === true ? true : false}
                                        value={formData.Description}
                                        onChange={handleInputChange}
                                        name="Description"
                                    />
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="RequisitionType" className="form-label">Requisition Type</label>
                                    {itemData?.requisitionNo === '' ?
                                        <Select isDisabled={itemData.eye === true ? true : false}
                                            value={formData.RequisitionType}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-70 p-0"
                                            menuPlacement="auto"
                                            menuShouldScrollIntoView={false}
                                            options={itemType}
                                            onChange={(selectedOption) => handleItemTypeChange(selectedOption)}
                                        /> :
                                        <Select isDisabled={itemData?.requisitionNo === '' ? false : true}
                                            value={formData.RequisitionType}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-70 p-0"
                                            menuPlacement="auto"
                                            menuShouldScrollIntoView={false}
                                            options={itemType}
                                            onChange={(selectedOption) => handleItemTypeChange(selectedOption)}
                                        />}
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="contactPerson" className="form-label">Contact Person</label>
                                    <input
                                        type="text" disabled={itemData.eye === true ? true : false}
                                        className="form-Input w-70"
                                        id="contactPerson"
                                        value={formData.contactPerson}
                                        onChange={handleInputChange}
                                        name="contactPerson"
                                    />
                                </div>
                            </div>
                            <div className="form-group row pb-3">
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="Remarks" className="form-label">Remarks</label>
                                    <input
                                        type="text" disabled={itemData.eye === true ? true : false}
                                        className="form-Input w-70"
                                        id="Remarks"
                                        value={formData.Remarks}
                                        onChange={handleInputChange}
                                        name="Remarks"
                                    />
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="QuotationReq" className="form-label">Quotation Req</label>
                                    <input disabled
                                        className="form-Input w-70"
                                        id="QuotationReq"
                                        value={formData.QuotationReq}
                                        name="QuotationReq"
                                    />
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="ContactNo" className="form-label">Contact No</label>
                                    <input
                                        type="number" onWheel={(e) => e.target.blur()}
                                        className="form-Input w-70"
                                        id="ContactNo" disabled={itemData.eye === true ? true : false}
                                        value={formData.ContactNo}
                                        onChange={handleInputChange}
                                        name="ContactNo"
                                    />
                                </div>
                            </div>
                            <div className="form-group row pb-3">
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="Description" className="form-label">Pay OrderType</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-70 p-0"
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        isDisabled={itemData.eye === true ? true : false}
                                        options={orderType} value={formData.OrderType}
                                        onChange={(selectedOption) => handlePyorderChange(selectedOption)}
                                    />
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="BuyerName" className="form-label">Buyer Name</label>
                                    <input
                                        type="text" disabled={itemData.eye === true ? true : false}
                                        className="form-Input w-70"
                                        id="BuyerName"
                                        value={formData.BuyerName}
                                        onChange={handleInputChange}
                                        name="BuyerName"
                                    />
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="BuyerName" className="form-label">Delivery Note No</label>
                                    <input
                                        type="text" disabled={itemData.eye === true ? true : false}
                                        className="form-Input w-70"
                                        id="deliveryNote"
                                        value={formData.deliveryNote}
                                        onChange={handleInputChange}
                                        name="deliveryNote"
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="col-2 p-2 brderbox center" onClick={() => handleOpen()} >
                                    {'Attachment'}
                                </div>

                            </div>
                        </>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Supplier Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <>
                            <div className="form-group row justify-content-between pb-3">
                                <div className="col d-flex align-items-center">
                                    <label htmlFor="inventoryAccountCode" className="form-label">Vendor ID</label>
                                    {itemData?.requisitionNo === '' ?
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })}
                                            isDisabled={itemData.eye === true ? true : false}
                                            value={SupplierID}
                                            options={suppliers?.map((sup) => ({ value: sup, label: sup?.record_Id }))}
                                            onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                        />
                                        :
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })}
                                            isDisabled={itemData?.vendorName ? true : false}
                                            value={SupplierID}
                                            options={suppliers?.map((sup) => ({ value: sup, label: sup?.record_Id }))}
                                            onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                        />
                                    }
                                </div>
                                <div className="col d-flex align-items-center">
                                    <label htmlFor="inventoryAccountCode" className="form-label">Vendor Name</label>
                                    {itemData?.requisitionNo === '' ?
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })}
                                            isDisabled={itemData.eye === true ? true : false}
                                            value={Supplier}
                                            options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                                            onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                        />
                                        :
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })}
                                            value={Supplier}
                                            isDisabled={itemData?.vendorName ? true : false}
                                            options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                                            onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                        />
                                    }
                                </div>
                                <div className="col d-flex align-items-center">
                                    <label htmlFor="inventoryAccountCode" className="form-label">Payment terms</label>
                                    {itemData?.requisitionNo === '' ?
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })}
                                            value={Payment} isDisabled={itemData.eye === true ? true : false}
                                            onChange={(selectedOption) => handlePayChange(selectedOption)}
                                            options={payments?.map((sup) => ({ value: sup, label: sup?.description }))}
                                        />
                                        :
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })}
                                            value={Payment} isDisabled={itemData?.vendorName ? true : false}
                                            onChange={(selectedOption) => handlePayChange(selectedOption)}
                                            options={payments?.map((sup) => ({ value: sup, label: sup?.description }))}
                                        />
                                    }

                                </div>
                            </div>
                            <div className="form-group row  pb-3">
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="inventoryAccountCode" className="form-label">Supplier Dept</label>
                                    {itemData?.requisitionNo === '' ?
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })} isDisabled={itemData.eye === true ? true : false}
                                            value={formData.SupplierDep}
                                            // options={department?.map((dep) => ({ value: dep, label: dep?.description }))}
                                            onChange={(selectedOption) => handleDepChange(selectedOption)}
                                        /> :
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })} isDisabled={itemData?.vendorName ? true : false}
                                            value={formData.SupplierDep}
                                            // options={department?.map((dep) => ({ value: dep, label: dep?.description }))}
                                            onChange={(selectedOption) => handleDepChange(selectedOption)}
                                        />}
                                </div>
                                <div className="col-4 d-flex justify-content-between">
                                    <label htmlFor="Property" className="form-label">Supplier Contact</label>
                                    {itemData?.requisitionNo === '' ?
                                        <input disabled={itemData.eye === true ? true : false}
                                            type="number" onWheel={(e) => e.target.blur()}
                                            className="form-Input w-75"
                                            id="SupplierContact"
                                            value={SupplierContact}
                                            onChange={handleInputChange}
                                            name="SupplierContact"
                                        /> :
                                        <input disabled={itemData?.vendorName ? true : false}
                                            type="number" onWheel={(e) => e.target.blur()}
                                            className="form-Input w-75"
                                            id="SupplierContact"
                                            value={SupplierContact}
                                            onChange={handleInputChange}
                                            name="SupplierContact"
                                        />}
                                </div>
                                <div className="col-4 pt-1 d-flex justify-content-between">
                                    <div className="d-flex justify-content-between">
                                        <div className="form-check">
                                            <input disabled={itemData.eye === true ? true : false}
                                                style={{ width: "26px", height: "26px" }}
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={isVatExcluded}
                                                onChange={handleVatChange}
                                            />
                                            <label className="form-check-label mx-2 mt-1">Vat Excluded</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setCostTab(!CostTab)}>
                    <div className="h6 pt-1">Cost Center Details</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <>
                            <div className="form-group row justify-content-between pb-3">
                                <div className="col d-flex align-items-center">
                                    <label htmlFor="inventoryAccountCode" className="form-label">Property</label>
                                    {itemData?.requisitionNo === '' ?
                                        <Select
                                            id="costCenter1" value={formData.costCenter1}
                                            onChange={handleCost1}
                                            options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8, padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            menuPlacement="auto"
                                            menuShouldScrollIntoView={false}
                                        /> :
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })}
                                            value={formData.costCenter1} isDisabled
                                            onChange={handleCost1}
                                            options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                                        />
                                    }
                                </div>
                                <div className="col d-flex align-items-center">
                                    <label htmlFor="inventoryAccountCode" className="form-label">Unit</label>
                                    {itemData?.requisitionNo === '' ?
                                        <Select
                                            id="costCenter2" value={formData.costCenter2}
                                            onChange={handleCost2}
                                            options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            menuPlacement="auto"
                                            menuShouldScrollIntoView={false}
                                        /> :
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })}
                                            value={formData.costCenter2}
                                            onChange={handleCost2}
                                            isDisabled
                                            options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                                        />
                                    }
                                </div>
                                <div className="col d-flex align-items-center">
                                    <label htmlFor="costCenter3" className="form-label me-2">{isXtreamCompany === false ? "Cost Center 3" : "Nature of Job"}</label>
                                    {itemData?.requisitionNo === '' ?
                                        <Select
                                            id="costCenter3" value={formData.costCenter3}
                                            onChange={handleCost3}
                                            options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            menuPlacement="auto"
                                            menuShouldScrollIntoView={false}
                                        /> :
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })}
                                            value={formData.costCenter3}
                                            onChange={handleCost3}
                                            isDisabled={itemData?.vendorName ? true : false}
                                            options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                                        />
                                    }
                                </div>
                            </div>
                            <div className="form-group row pb-3">
                                <div className="col-4 d-flex align-items-center">
                                    <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">{isXtreamCompany === false ? "Cost Center 4" : "Work Order No"}</label>
                                    {itemData?.requisitionNo === '' ?
                                        <Select
                                            id="costCenter4" value={formData.costCenter4}
                                            onChange={handleCost4}
                                            options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            menuPlacement="auto"
                                            menuShouldScrollIntoView={false}
                                        /> :
                                        <Select
                                            className="flex-grow-1"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                padding: 9
                                            })}
                                            value={formData.costCenter4}
                                            onChange={handleCost4}
                                            isDisabled={itemData?.vendorName ? true : false}
                                            options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                                        />
                                    }
                                </div>

                            </div>
                        </>
                    </div>
                </div>
            </div>
            <div className="slide-container p-2 mt-3">
                <div className="container-fluid">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Items
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Terms
                        </div>
                    </div>

                </div>
            </div>
            <div className="grid-1 brderbox2 p-4 mb-3">
                {gridVisibility[0] && (
                    <UpdateItemGrid onRequisitionData={handleRequisitionData} itemData={itemData} selectedCheck={isVatExcluded} handleVatChange={handleVatChange}
                        currencyPrecision={currencyPrecision?.precision || 3} setLoader={setLoader} loader={loader} />
                )}
                {gridVisibility[1] && (
                    <Authorization
                        handleAuthorization={handleAuthorization}
                        usersDetails={usersDetails}
                        setUser={setUser}
                        itemData={itemData}
                    />
                )}
                {gridVisibility[2] && (
                    <div className="grid-3 border">
                        <MessageGrid handleMessage={handleMessage} />
                    </div>
                )}
            </div>
            <UpdateAttachment
                open={attachmentModal}
                rows={attachments}
                documentNo={poNumber}
                readOnly={itemData?.eye}
                onView={handleView}
                onFileSelect={handleFileSelect}
                onRemarkChange={handleRemarkChange}
                onDelete={handleDelete}
                previewImage={previewImage}
                previewOpen={previewModal}
                preview={preview}
                onClose={closeModal}
                closePreview={() => setPreviewModal(false)}
            />
        </div >

    )
}

export default UpdatePurchaseOrder